import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';

@Component({
  selector: 'core-input-email',
  templateUrl: 'input-email.component.html',
  styleUrls: ['input-email.component.scss', '../core-input.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: InputEmailComponent,
    multi: true
  }]
})
export class InputEmailComponent implements ControlValueAccessor, OnInit {

  @Input() id: string;
  @Input() label: string;
  @Input() floatLabel: string;
  @Input() topLabel: string;
  @Input() placeholder: string = '';
  @Input() showClearButton: boolean = true;

  @Input() removeDefaultBottomErrorMargin: boolean = false;

  @Output() onKeyUpEnter = new EventEmitter<string>();

  control: NgControl;

  value: string;
  disabled = false;
  private onTouched: Function;
  private onChanged: Function;

  constructor(private inj: Injector) {
    if (!this.id) {
      this.id = 'core-input-email-' + Math.random();
    }
  }

  ngOnInit() {
    this.control = this.inj.get(NgControl)
  }

  onClear() {
    this.valueChanged(null);
    this.onKeyUpEnter.emit(null)
  }

  valueChanged(value: string) {
    this.onTouched();
    this.value = value;
    this.onChanged(value);
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: Function): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

}
